import axios from 'axios';
import { store } from '../store/store';

export const appkey = "7a75e1a4f3440165cae07894b45890dcffabdd74f03f87d790f56d5e"
export const facialBaseURL = process.env.REACT_APP_BASEURL_FACIAL;
export const ParametreBaseURL = process.env.REACT_APP_BASEURL_ADMIN_BACKEND+"/Parameter" ;
export const ConsultationBaseURL = process.env.REACT_APP_BASEURL_CONSULTATION_BACKEND;
export const ClientBaseURL = process.env.REACT_APP_BASEURL_CLIENT_BACKEND;

export const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASEURL_FACIAL,
});

export const faceApiForUrl = axios.create({
    baseURL: facialBaseURL,
    timeout: 50000,
    headers: {
        "x-api-key": appkey,
        "Content-Type": "multipart/form-data",
    },
    mimeType: "multipart/form-data",
    contentType: false,
    params: {

    }
});
export const faceApiForUpload = axios.create({
    baseURL: facialBaseURL,
    timeout: 50000,
    headers: {
        "x-api-key": appkey,
        "Content-Type": "multipart/form-data",
    },
    params: {
    }
});
export const clientMicroserviceApi = axios.create({
    baseURL: facialBaseURL,
    timeout: 50000,
    headers: {
        'Ocp-Apim-Subscription-Key': '73333733a76c424b9e88cf044edb9892',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+JSON.parse(localStorage.getItem('userDetails'))?.token
    },
    params: {
    }
});
export const ParametreMicroserviceApi = axios.create({
    baseURL: ParametreBaseURL,
    timeout: 50000,
    headers: {
        'Authorization': 'Bearer '+JSON.parse(localStorage.getItem('userDetails'))?.token,
        'Content-Type': 'application/json'
    },
    params: {
    }
});
export const ConsultationMicroserviceApi = axios.create({
    baseURL: ConsultationBaseURL,
    timeout: 50000,
    headers: {
        'Authorization': 'Bearer '+JSON.parse(localStorage.getItem('userDetails'))?.token,
        'Content-Type': 'application/json'
    },
    params: {
    }
});

export const localClientMicroserviceApi = axios.create({
    baseURL: ClientBaseURL,
    timeout: 50000,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+JSON.parse(localStorage.getItem('userDetails'))?.token
    },
    params: {
    }
});